<template>
<el-dialog  title="批量开票" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="plkpFlag" width="1320px" center>
  <div>
    <el-form :inline="true" ref="dataForm" enctype="multipart/form-data" :model="dataForm" :rules="rules"  class="demo-form-inline" label-width="100px" size="mini">
      <el-form-item label="开票时间:" prop="invoiceTime">
        <el-date-picker
          v-model="dataForm.invoiceTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="timestamp"
          placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
      <div class="box">
        <div class="left">
          <el-form-item label="发票二维码:" class="is-required"  >
          <el-radio-group v-model="moban" @change="mobanChange"  >
            <el-radio label="发票二维码（有销售方）">新模板(有销售方)</el-radio>
            <el-radio label="发票二维码">旧模板(无销售方)</el-radio>
          </el-radio-group>
          </el-form-item>
          <div class="imgBox">
            <el-upload action="" ref="imgref" :auto-upload=false :multiple=true :file-list="imgList" :on-change="imgPreview" list-type="picture-card" accept="image/*" :limit="10"
            :disabled="delFlag" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :class="[isAdd?'hidden':'']">
            </el-upload>
          </div>
          <!-- <div class="tubiaoBox">
            <div style="margin-right:20px"><span class="tubiao" style="background-color: #67C23A;"></span>账单匹配成功</div>
            <div><span class="tubiao" style="background-color: #F56C6C;"></span>账单匹配失败</div>
          </div> -->
        </div>
        <div class="right">
          <el-form-item label="匹配申请流水:"  >
            <el-button type="primary" @click="cxppFn">重新匹配</el-button>
          </el-form-item>
          <el-table :data="imgList"    border size="mini" style="" >
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column prop="applyNo" label="申请流水" align="center" width="160"></el-table-column>
          <el-table-column prop="payer" label="结算客户" align="center" width="220">
            <template slot-scope="scope">
              <div class="fapiaohao">
                <el-form-item label=""  :key="scope.$index"  >
                  <el-input placeholder="" maxlength="50"
                    v-model="imgList[scope.$index].payer" ></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="invoiceAmount" label="开票金额(元)"  width="110" align="center" >
            <template slot-scope="scope">
              <div>
                <el-form-item label=""  :key="scope.$index"  >
                  <el-input placeholder="" maxlength="30" style=" width: 98px;"
                    v-model="imgList[scope.$index].invoiceAmount" ></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="发票号" min-width="240">
            <template slot-scope="scope">
              <div class="fapiaohao">
                <el-form-item label=""  :key="scope.$index"  >
                  <el-input placeholder="" maxlength="30"
                    v-model="imgList[scope.$index].invoiceNo" ></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
        </el-table>
        </div>
      </div>
    </el-form>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="saveFn('dataForm')">确 定</el-button>
  </span>
  <el-image-viewer v-if="dialogVisible" :on-close="closeViewer" :url-list="lookimgList" />
</el-dialog>
</template>
<script>
import { ocrCustomModelByFile, ocrModelList, matchInvoiceApply, confirmInvoiceApply } from '@/api/newTMS'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  components: { ElImageViewer },
  name: 'xiugaiSG',
  props: {
    plkpFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modelId: '',
      dataForm: {},
      imgList: [],
      dataList: [],
      lookimgList: [],
      isAdd: false,
      dialogVisible: false,
      delFlag: false,
      max: 10,
      rules: {
        invoiceTime: [
          { required: true, message: '请选择开票时间', trigger: 'blur' }
        ]
      },
      moban: '发票二维码（有销售方）',
      changeTimer: null
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    ocrModelList({ labelList: ['唐山曹妃甸兴瀚钢铁物流有限公司'], modelName: this.moban }).then(res => {
      this.modelId = JSON.parse(res)[0].id
    })
    this.$set(this.dataForm, 'invoiceTime', new Date().getTime())
  },
  methods: {
    // 重新匹配
    cxppFn () {
      if (this.imgList.length == 0) {
        this.$alert('暂无要匹配的数据', '系统提示')
        return
      }
      let flag = this.imgList.some(item => !item.invoiceNo)
      if (flag) {
        this.$alert('有的申请流水，没有发票号，请输入发票号', '系统提示')
        return
      }
      let flag1 = this.imgList.some(item => !item.payer)
      if (flag1) {
        this.$alert('有的申请流水，没有结算客户，请输入结算客户', '系统提示')
        return
      }
      let flag2 = this.imgList.some(item => !item.invoiceAmount)
      if (flag2) {
        this.$alert('有的申请流水，没有开票金额，请输入开票金额', '系统提示')
        return
      }
      let arr = []
      this.imgList.forEach(item => {
        arr.push({
          invoiceNo: item.invoiceNo ? item.invoiceNo : null,
          pendingAmount: item.invoiceAmount ? item.invoiceAmount : null,
          payer: item.payer ? item.payer : null
        })
      })
      const loading = this.$loading({
        lock: true,
        text: '正在匹配...'
      })
      matchInvoiceApply(arr).then(res => {
        console.log('res', res)
        let liDom = this.$refs.imgref.$children[0].$children[0].children
        console.log('liDom', liDom)
        res.forEach((item, index) => {
          if (item.applyNo) {
            this.$set(this.imgList[index], 'applyNo', item.applyNo)
            this.$set(this.imgList[index], 'id', item.id)
            liDom[index].elm.classList.add('chenggong')
            liDom[index].elm.classList.remove('shibai')
          } else {
            this.$set(this.imgList[index], 'applyNo', '暂无匹配')
            liDom[index].elm.classList.add('shibai')
            liDom[index].elm.classList.remove('chenggong')
          }
        })
        loading.close()
        this.$message({
          showClose: true,
          message: '匹配完成',
          type: 'success',
          onClose () {
            loading.close()
          }
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 模板改变
    mobanChange () {
      ocrModelList({ labelList: ['唐山曹妃甸兴瀚钢铁物流有限公司'], modelName: this.moban }).then(res => {
        this.modelId = JSON.parse(res)[0].id
      })
    },
    // 保存
    saveFn (formName) {
      let flag = this.imgList.some(item => !item.invoiceNo)
      if (flag) {
        this.$alert('有的申请流水，没有发票号，请输入发票号', '系统提示')
        return
      }
      let flag1 = this.imgList.some(item => !item.payer)
      if (flag1) {
        this.$alert('有的申请流水，没有结算客户，请输入结算客户', '系统提示')
        return
      }
      let flag2 = this.imgList.some(item => !item.invoiceAmount)
      if (flag2) {
        this.$alert('有的申请流水，没有开票金额，请输入开票金额', '系统提示')
        return
      }
      let arr = []
      this.imgList.forEach(item => {
        if (item.id) {
          arr.push(item)
        }
      })
      if (arr.length == 0) {
        this.$alert('没有匹配上的数据，请重新选择二维码图片或者重新匹配', '系统提示')
        return
      }
      const Ids = new Set(arr.map(item => item.id))
      if (arr.length !== Ids.size) {
        this.$alert('有重复的申请流水，请先处理', '系统提示')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          let qq = arr.map((item, index) => {
            let imgfile = new FormData()
            imgfile.set('params', JSON.stringify({
              invoiceTime: this.dataForm.invoiceTime,
              id: item.id,
              invoiceAmount: item.invoiceAmount,
              invoiceNo: item.invoiceNo

            }))
            imgfile.append('filesQr', item.raw)
            return new Promise((resolve, reject) => {
              confirmInvoiceApply(imgfile).then(res => {
                resolve(res)
              }).catch(error => {
                loading.close()
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                  }
                })
              })
            })
          })
          Promise.all(qq).then(value => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.$emit('update:plkpFlag', false)
            this.$parent.searchFn()
          })
        }
      })
    },
    // 图片上传
    handleRemove (file, fileList) {
      if (fileList.length < this.max) {
        this.isAdd = false
      }
      const index = this.imgList.findIndex(f => f.uid === file.uid)
      this.imgList.splice(index, 1)
      if (this.changeTimer) clearTimeout(this.changeTimer)
      this.changeTimer = setTimeout(() => {
        this.classFN()
        this.changeTimer = null
      }, 1000)
      this.lookimgList = []
      fileList.forEach((item, index) => {
        this.$set(this.lookimgList, index, item.url)
      })
    },
    imgPreview (file, fileList) {
      if (this.changeTimer) clearTimeout(this.changeTimer)
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.png|)$/
      if (regex.test(fileName.toLowerCase())) {
        this.lookimgList = []
        fileList.forEach((item, index) => {
          this.$set(this.lookimgList, index, item.url)
        })
        if (fileList.length < this.max) {
          this.isAdd = false
        } else {
          this.isAdd = true
        }
        this.imgList.push(file)
        // 批量ocr识别
        this.changeTimer = setTimeout(() => {
          this.plOcr()
          this.changeTimer = null
        }, 1000)
      } else {
        fileList.pop()
        this.$alert('不支持此类型', '系统提示')
        return false
      }
    },
    // 批量ocr识别
    plOcr () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      let qq = this.imgList.map((item, index) => {
        if (!item.invoiceNo) {
          let imgfile = new FormData()
          imgfile.set('params', JSON.stringify({ modelId: this.modelId }))
          imgfile.append('file', item.raw)
          return new Promise((resolve, reject) => {
            ocrCustomModelByFile(imgfile).then(res => {
              resolve(res)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                }
              })
              resolve(JSON.stringify(error))
            })
          })
        } else {
          return new Promise((resolve, reject) => {
            resolve(false)
          })
        }
      })
      Promise.all(qq).then(value => {
        loading.close()
        value.forEach((item, index) => {
          let data = JSON.parse(item)
          if (item && data.invoiceNo) {
            this.$set(this.imgList[index], 'invoiceNo', data.invoiceNo)
            this.$set(this.imgList[index], 'invoiceAmount', data.invoiceAmount.replace(/[^\d\.]/g, ''))
            this.$set(this.imgList[index], 'payer', data.payer.replace(/\./g, ''))
          }
        })
        let arr = []
        this.imgList.forEach(item => {
          console.log(item)
          arr.push({
            invoiceNo: item.invoiceNo ? item.invoiceNo : null,
            pendingAmount: item.invoiceAmount ? item.invoiceAmount : null,
            payer: item.payer ? item.payer : null
          })
        })
        matchInvoiceApply(arr).then(res => {
          let liDom = this.$refs.imgref.$children[0].$children[0].children
          res.forEach((item, index) => {
            if (item.applyNo) {
              this.$set(this.imgList[index], 'applyNo', item.applyNo)
              this.$set(this.imgList[index], 'id', item.id)
              liDom[index].elm.classList.add('chenggong')
            } else {
              this.$set(this.imgList[index], 'applyNo', '暂无匹配')
              liDom[index].elm.classList.add('shibai')
            }
          })
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      })
    },
    // 给样式
    classFN () {
      let liDom = this.$refs.imgref.$children[0].$children[0].children
      this.imgList.forEach((item, index) => {
        if (item.id) {
          liDom[index].elm.classList.add('chenggong')
        } else {
          liDom[index].elm.classList.add('shibai')
        }
      })
    },
    closeViewer () {
      this.dialogVisible = false
      this.classFN()
    },
    handlePictureCardPreview (file) {
      if (this.lookimgList.length == 0) {
        this.imgList.forEach((item, index) => {
          this.lookimgList.push(item.url)
        })
        this.lookimgList.forEach((item, index) => {
          if (item == file.url) {
            this.lookimgList = this.lookimgList.slice(index).concat(this.lookimgList.slice(0, index))
            this.dialogVisible = true
          }
        })
      } else {
        this.lookimgList.forEach((item, index) => {
          if (item == file.url) {
            this.lookimgList = this.lookimgList.slice(index).concat(this.lookimgList.slice(0, index))
            this.dialogVisible = true
          }
        })
      }
    },
    closeDialog () {
      this.$emit('update:plkpFlag', false)
    }
  }

}
</script>

<style scoped lang='less'>
.box{
  display: flex;
  justify-content: space-between;
}
.left,.right{
  width: 38%;
}
.right{
  width: 60%;
}
/deep/.el-upload-list__item{
  position: relative;
}
/deep/.chenggong::after {
  content: "成功";
  background-color: #67C23A;
  color: #fff;
  height: 18px;
  width: 26px;
  font-size: 10px;
  text-align: center;
  line-height: 18px;
  // border-radius: 50%;
  position: absolute;
  top:0px;
  right:0px
}
/deep/.shibai::after {
  content: "失败";
  background-color: red;
  color: #fff;
  height: 18px;
  width: 26px;
  font-size: 10px;
  text-align: center;
  line-height: 18px;
  // border-radius: 50%;
  position: absolute;
  top:0px;
  right:0px
}
.tubiaoBox{
  display: flex;
  margin-top: 8px;
}
.tubiao{
  display: inline-block;
  margin-right: 2px;
  color: #fff;
  height: 20px;
  width: 20px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
}
.fapiaohao{
  /deep/.el-input__inner{
    padding: 0px 6px;
    width: 200px;
  }
}
</style>
